import { mapCollection } from '../../utils/collection.utils';
import { ModelCurrentTaskIncidenceTotals } from '../summary/model-current-task-incidence-totals';

export class ModelCurrentTaskIncidenceTotalsBuilder {
  static fromJson(json) {
    return (json)
      ? new ModelCurrentTaskIncidenceTotals(
        json.finished,
        json.scrapped,
        json.recoverable,
        json.totals
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ModelCurrentTaskIncidenceTotalsBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/model-current-task-incidence-totals.builder.ts